import React from 'react';

export default class Footer extends React.Component {
    constructor(props){
        super(props)
        
        this.state = {
			IsLoggedIn: false,
			Year: new Date()
        }
        
    }
	
	render() {
		return (
			<footer className="clearfix">
				<section className="clearfix">
					<div className="col-12" id="footerBottom">
						Copyright &copy; {this.state.Year.getFullYear()}. WUBART LLC  All Rights Reserved.
						<div className="floatRight">
							<a href="/terms.cfm">Terms and Conditions</a>&nbsp; | &nbsp;<a href="/privacy.cfm">Privacy Policy</a>&nbsp; | &nbsp;<a href="/contact.cfm">Contact Us</a>
						</div>
					</div>
				</section>
			</footer>
		)
	}
}


/** WEBPACK FOOTER **
 ** ./app/reusable/footer.js
 **/